module.exports = __webpack_public_path__ + "img/dubMerch.e7ff7b13.png";